import { render, staticRenderFns } from "./cowTable.vue?vue&type=template&id=c67b1672&scoped=true"
import script from "./cowTable.vue?vue&type=script&lang=js"
export * from "./cowTable.vue?vue&type=script&lang=js"
import style0 from "./cowTable.vue?vue&type=style&index=0&id=c67b1672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b1672",
  null
  
)

export default component.exports